export const templates = {
  PLACEMENTS_ADDED_TO_BLACKLIST: 'placementsAddedToBlacklist',
  PLACEMENTS_ADDED_TO_WHITELIST: 'placementsAddedToWhitelist',
  PLACEMENTS_REMOVED_FROM_BLACKLIST: 'placementsRemovedFromBlacklist',
  PLACEMENTS_REMOVED_FROM_WHITELIST: 'placementsRemovedFromWhitelist',
  PLACEMENTS_NOT_ADDED_TO_WHITELIST: 'placementsNotAddedToWhitelist',
  PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_WHITELIST:
    'placementsNotAddedToBlacklistBecauseOfWhitelist',
  PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_BLACKLIST:
    'placementsNotAddedToBlacklistBecauseOfBlacklist',
  PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_LIMIT: 'placementsNotAddedToBlacklistBecauseOfLimit',

  ADS_CHANGED_STATUS: 'adsChangedStatus',
  ADS_ADDED_TO_EXCEPTIONS: 'adsAddedToExceptions',
  ADS_REMOVED_FROM_EXCEPTIONS: 'adsRemovedFromExceptions',
  ADS_ENABLED_AND_ADDED_TO_EXCEPTIONS: 'adsEnabledAndAddedToExceptions',

  KEYWORDS_CHANGED_STATUS: 'keywordsChangedStatus',
  KEYWORDS_ADDED_TO_EXCEPTIONS: 'keywordsAddedToExceptions',
  KEYWORDS_REMOVED_FROM_EXCEPTIONS: 'keywordsRemovedFromExceptions',
  KEYWORDS_ENABLED_AND_ADDED_TO_EXCEPTIONS: 'keywordsEnabledAndAddedToExceptions',

  ACTION_NOT_PERMITTED: 'actionNotPermitted'
}

export function createHtmlMessageFromList(list) {
  return list.reduce((html, item) => `${html}<i>${item}</i><br />`, '')
}

export function createWhitelistNotification(data) {
  const {
    addedPlacements,
    whitelisted,
    addedCount,
    whitelistAddLogId,
    whitelistDeleteLogId,
    deletedPlacements
  } = data
  const notifications = []

  if (addedCount) {
    notifications.push({
      count: addedCount,
      logId: whitelistAddLogId,
      list: addedPlacements,
      template: templates.PLACEMENTS_ADDED_TO_WHITELIST
    })
  }

  if (whitelisted && whitelisted.length) {
    notifications.push({
      list: whitelisted,
      template: templates.PLACEMENTS_NOT_ADDED_TO_WHITELIST
    })
  }

  if (deletedPlacements && deletedPlacements.length) {
    notifications.push({
      logId: whitelistDeleteLogId,
      list: deletedPlacements,
      // TODO: should get count from response
      count: deletedPlacements.length,
      template: templates.PLACEMENTS_REMOVED_FROM_WHITELIST
    })
  }

  return notifications
}

export function createBlacklistNotification(data) {
  const {
    bannedPlacements,
    countBanned,
    addLogId,
    unbannedPlacements,
    countUnbanned,
    deleteLogId,
    blacklist,
    whitelist,
    excess
  } = data
  const notifications = []

  if (countBanned) {
    notifications.push({
      count: countBanned,
      logId: addLogId,
      list: bannedPlacements,
      template: templates.PLACEMENTS_ADDED_TO_BLACKLIST
    })
  }
  if (countUnbanned) {
    notifications.push({
      count: countUnbanned,
      logId: deleteLogId,
      list: unbannedPlacements,
      template: templates.PLACEMENTS_REMOVED_FROM_BLACKLIST
    })
  }
  if (whitelist && whitelist.length) {
    notifications.push({
      list: whitelist,
      template: templates.PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_WHITELIST
    })
  }
  if (blacklist && blacklist.length) {
    notifications.push({
      list: blacklist,
      template: templates.PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_BLACKLIST
    })
  }
  if (excess) {
    notifications.push({
      excess,
      template: templates.PLACEMENTS_NOT_ADDED_TO_BLACKLIST_BECAUSE_OF_LIMIT
    })
  }

  return notifications
}
